import script from "./OriginDestinationMarkers.vue?vue&type=script&setup=true&lang=js"
export * from "./OriginDestinationMarkers.vue?vue&type=script&setup=true&lang=js"

import "./OriginDestinationMarkers.vue?vue&type=style&index=0&id=5ab59881&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab59881"]])

export default __exports__